import {
  SoapContent,
  SoapContentItem,
  SoapSectionKeys,
} from '@/shared/types/yakurekiSoap'

/**
 * SoapContentItem配列から文字列配列を抽出
 */
export const extractContentStrings = (items: SoapContentItem[]): string[] => {
  return items.map((item) => item.content)
}

/**
 * 特定のセクションから文字列配列を取得
 */
export const getSectionContentStrings = (
  content: SoapContent,
  sectionKey: SoapSectionKeys
): string[] => {
  const section = content[sectionKey]

  if (!section || !Array.isArray(section)) {
    return []
  }

  return section.map((item) => item.content)
}

/**
 * 特定のセクションからSoapContentItem配列を取得
 */
export const getSectionContentItems = (
  content: SoapContent,
  sectionKey: SoapSectionKeys
): SoapContentItem[] => {
  const section = content[sectionKey]

  if (!section || !Array.isArray(section)) {
    return []
  }

  return section
}
